import { FC } from 'react';
import { Box, HStack, Link, Text } from '@chakra-ui/react';

import styles from './HeaderLogo.module.scss';

export interface HeaderLogoProps {
  programName?: string;
}

export const HeaderLogo: FC<HeaderLogoProps> = ({
  programName = 'Fundraising',
}) => (
  <Link
    href="https://www.stjude.org"
    textDecoration="none"
    _hover={{ textDecoration: 'none' }}
  >
    <HStack>
      <Box className={styles.sjLogo} w={['4.0rem', '5.5rem']} />
      <Box fontSize={['md', 'xl']} color="brand.primary.swatch1">
        <Text fontWeight="800" lineHeight="1">
          St. Jude
        </Text>
        <Text fontWeight="400">{programName}</Text>
      </Box>
    </HStack>
  </Link>
);
